import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Spinner from '@dashboard/components/Spinner';
import ReactFrappeChart from 'react-frappe-charts';

const StyledStatistic = styled.div`
  display: flex;
  align-items: center;
  height: 150px;
`;

const ChartTitle = styled.div`
  width: 25%;
  min-width: 100px;
`;

const propTypes = {
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      values: PropTypes.array,
    }),
  ]).isRequired,
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  tooltipOptions: PropTypes.shape({
    formatTooltipX: PropTypes.func,
    formatTooltipY: PropTypes.func,
  }),
};

const defaultProps = {
  total: 0,
  error: '',
  tooltipOptions: {
    formatTooltipX: null,
    formatTooltipY: null,
  },
};

const Statistic = ({ isLoading, title, data, total, error, tooltipOptions }) => (
  <StyledStatistic>
    <ChartTitle>
      <div className="text-gray-700 ">{title}</div>
      <h2 className="mt-1 text-black min-h-[27px]">{!isLoading ? total : ''}</h2>
    </ChartTitle>

    {(() => {
      if (isLoading) {
        return <Spinner className="m-auto" />;
      }

      if (!data || error) {
        return <div className="m-auto text-center text-black">{error}</div>;
      }

      return (
        <div className="flex-1">
          <ReactFrappeChart
            data={data}
            type="line"
            height={150}
            colors={['#dae1e7']}
            tooltipOptions={tooltipOptions}
          />
        </div>
      );
    })()}
  </StyledStatistic>
);

Statistic.propTypes = propTypes;
Statistic.defaultProps = defaultProps;

export default Statistic;
